import { render, staticRenderFns } from "./phoneSettingsIndex.vue?vue&type=template&id=2d5dd9db&scoped=true"
import script from "./phoneSettingsIndex.vue?vue&type=script&lang=js"
export * from "./phoneSettingsIndex.vue?vue&type=script&lang=js"
import style0 from "./phoneSettingsIndex.vue?vue&type=style&index=0&id=2d5dd9db&prod&lang=css"
import style1 from "./phoneSettingsIndex.vue?vue&type=style&index=1&id=2d5dd9db&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5dd9db",
  null
  
)

export default component.exports